import { Breadcrumbs, Grid, Typography, Link } from "@mui/material";
import React, { useEffect, useState } from "react";
import useForm, { Form } from "../../../../hooks/useForm";
import useQueryConfig from "../../../../hooks/useQueryConfig";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { path } from "../../../../constants/path";
import { validationReleaseGroupInput } from "../../utils/validateInput";
import {
  createReleaseGroup,
  getReleaseGroupDetail,
  updateReleaseGroup,
} from "../../../../apis/VersionRelease/group.api";
import { CACHE_RELEASE_GROUP } from "../../../../constants/actionCache";
import useCurrentActionCache from "../../../../hooks/useCurrentActionCache";
import { isDisableSubmit } from "../../utils";
import Controls from "../../../../components/form/controls/Controls";
import useDebounce from "../../../../hooks/useDebounce";
import CheckBoxTagProDevice from "./CheckBoxTagProDevice";
import { getProfileDevice } from "../../../../apis/profileDevice.api";

const initialValue = {
  id: "",
  name: "",
  listMacAddress: [],
};

const ReleaseGroupProDeviceAction = () => {
  // cache
  const { setCurrentActionCache } = useCurrentActionCache();

  let queryConfig = useQueryConfig();

  const { page = 1, limit = 10 } = queryConfig;

  let { id } = useParams();
  const history = useHistory();
  const [profileDevices, setProfileDevices] = useState([]);
  const [lisProfileDeviceDefault, setListProfileDeviceDefault] = useState([]);

  const [releaseGroup, setReleaseGroup] = useState([]);
  const [inputSearch, setInputSearch] = useState("");

  const [createAnother, setCreateAnother] = useState(false);

  let debouncedSearchValue = useDebounce(inputSearch, 500);

  useEffect(() => {
    // * Get list profile device
    getProfileDevice(
      { keySearch: debouncedSearchValue, limit: 50 },
      (result) => {
        setProfileDevices([
          ...result.list,
          // ...(releaseGroup.profileDevices || []),
        ]);
      }
    );
  }, [debouncedSearchValue]);

  useEffect(() => {
    if (id) {
      getReleaseGroupDetail(id, (result) => {
        const listMacAddress = result.profileDevices.map(
          (profileDevice) => profileDevice.macAddress
        );

        const value = {
          ...result,
          listMacAddress,
        };
        setValues({ ...value });
        setReleaseGroup({ ...value });
        setListProfileDeviceDefault([...result.profileDevices]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // validation input permission
  const validateFLFReleaseGroupForm = (fieldValues = values) => {
    let temp = validationReleaseGroupInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFReleaseGroupForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFReleaseGroupForm()) {
      if (!id) {
        createReleaseGroup(values, (result) => {
          if (result.data?.status === 422) {
            setErrors({ ...result.data.data });
          } else {
            setCurrentActionCache(CACHE_RELEASE_GROUP);
            if (createAnother) {
              resetForm();
            } else {
              history.push(`${path.releaseGroup}?page=${page}&limit=${limit}`);
            }
          }
        });
      } else {
        updateReleaseGroup(values.id, values, (result) => {
          if (result.data?.status === 422) {
            setErrors({ ...result.data.data });
          } else {
            setCurrentActionCache(CACHE_RELEASE_GROUP);
            if (createAnother) {
              resetForm();
            } else {
              history.push(`${path.releaseGroup}?page=${page}&limit=${limit}`);
            }
          }
        });
      }
    }
  };

  const handleSelectProfileDevice = (listProfileDevice) => {
    const listMacAddress = listProfileDevice.map(
      (profileDevice) => profileDevice.macAddress
    );

    setValues({ ...values, listMacAddress });
  };

  return (
    <>
      <>
        <div className="page-header">
          <h2>{id ? "Edit Release Group" : "Add Release Group"}</h2>
        </div>

        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline="hover"
            color="inherit"
            href={`/ota/release-group?page=${page}&limit=${limit}`}
          >
            Release Group
          </Link>
          <Typography color="text.primary">
            {id ? "Edit Release Group" : "Add Release Group"}
          </Typography>
        </Breadcrumbs>

        <Form onSubmit={onSubmit} noValidate>
          <Grid container>
            <Grid item xs={6} p={5}>
              <Controls.Input
                name="name"
                value={values.name}
                label="Name"
                type="text"
                onChange={handleInputChange}
                error={errors.name}
              />

              <CheckBoxTagProDevice
                options={profileDevices}
                labelFields={["macAddress"]}
                setInputSearch={setInputSearch}
                onChange={(value) => handleSelectProfileDevice(value)}
                defaultValue={lisProfileDeviceDefault}
              />

              {!id ? (
                <Controls.Checkbox
                  name="createAnother"
                  label="Create another"
                  value={createAnother}
                  onChange={() => setCreateAnother(!createAnother)}
                />
              ) : null}

              <Controls.Button
                sx={{ width: "100%", marginTop: "10px" }}
                type="submit"
                text="Submit"
                disabled={isDisableSubmit(releaseGroup, values)}
              />
            </Grid>
            <Grid item xs={6} p={5}></Grid>
          </Grid>
        </Form>
      </>
    </>
  );
};

export default ReleaseGroupProDeviceAction;
